import React, { useState, useEffect } from "react";
import Sidenavbar from "../../Sidenavbar";
import Topbar from "../../Topbar";
import "../../../styles/CommonStyle.scss";
import "../../../styles/Designation.scss";
import { Col, Row } from "react-bootstrap";
import { baseURL } from "../../BaseUrl";
import { exportExcel } from "../../DownloadFile";
import Select from "react-select";
import { optionsStatusList } from "../../DropdownsData";
import { loggedInRole } from "../../LoginRole";
import AccessDenied from "../../../AccessDenied";
import AddDesignation from "./AddDesignation";
import SbAddBtn, { SbDownloadBtn } from "../../SbButtons/SbAddBtn";
import {
  loadPageBreadCome,
  loadDepasrtDesignation,
  loadDepartmentDrop,
  loadRolesDropDown,
} from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { MiClearButton } from "../../SbButtons/SbCancelBtn";
import { useNavigate } from "react-router-dom";
import DesignationTable from "./DesignationTable";
import Footer from "../../Footer";
import { travelizeAuth } from "../../HeaderAuthentication";
import DownloadLoading from "../../ReUseComponents/DownloadLoading";

export default function Designation() {
  let dispatch = useDispatch();
  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));
  const { departDesignation } = useSelector((state) => state.data);
  const { rolesDropdown } = useSelector((state) => state.data);
  const { departmentDrop } = useSelector((state) => state.data);

  const [menuCollapse, setMenuCollapse] = useState(false);
  const [designationData, setDesignationData] = useState([]);
  const [activeStatus, setActiveStatus] = useState(2);
  const [designationId, setDesignationId] = useState(0);
  const [departmentId, setDepartmentId] = useState(0);
  const [editDesignationID, setEditDesignationID] = useState(0);
  const [roleId, setRoleId] = useState(0);
  const [show, setShow] = useState(false);
  const [toggleshift, setToggleshift] = useState({ style: "" });
  const [isLoading, setIsLoading] = useState(true);
  const [downloadIsLoading, setDownloadIsLoading] = useState(false);

  let tableHeader = [
    { name: "SL.NO.", align: "center", width: "80px" },
    { name: "DESIGNATION", align: "left", width: "150px" },
    { name: "LEVEL", align: "center", width: "80px" },
    { name: "DEPARTMENT", align: "left", width: "150px" },
    { name: "ROLE", align: "left", width: "150px" },
    { name: "REPORTING", align: "left", width: "150px" },
    { name: "DESCRIPTION", align: "left", width: "200px" },
    { name: "ADDED BY", align: "left", width: "150px" },
    { name: "STATUS", align: "center", width: "120px" },
    { name: "ACTION", align: "center", width: "120px" },
  ];

  const toggleMenu = () => {
    if (menuCollapse) {
      setMenuCollapse(false);
      setToggleshift({ style: "" });
    } else {
      setMenuCollapse(true);
      setToggleshift({ style: "toggle-shift-left" });
    }
  };

  // PAGINATION START
  const [PageSize, setPageSize] = useState(20);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  // PAGINATION END

  const handleClose = () => {
    setShow(false);
    setEditDesignationID(0);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    let breadCome = { mainpage: "Designation" };
    dispatch(loadPageBreadCome(breadCome));
    dispatch(loadDepartmentDrop());
    dispatch(loadDepasrtDesignation(departmentId));
    dispatch(loadRolesDropDown());
  }, [departmentId]);

  // GET  PAGE START
  useEffect(() => {
    fetchDesignations();
  }, [
    designationId,
    roleId,
    departmentId,
    activeStatus,
    PageSize,
    currentPage,
  ]);

  const fetchDesignations = () => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(
      `${baseURL}/api/Designation/Get?DesignationID=${designationId}&RoleID=${roleId}&DepartmentID=${departmentId}&Status=${activeStatus}&PageSize=${PageSize}&CurrentPage=${currentPage}`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setDesignationData(res.result);
          setPageCount(Math.ceil(res.recordCount[0] / PageSize));
          setTotalData(res.recordCount[0]);
          setIsLoading(false);
          setLoading(false);
        } else {
          setDesignationData("");
          setIsLoading(false);
          setLoading(false);
        }
      });
  };
  // GET  PAGE END

  const [openFilterTab, setOpenFilterTab] = useState(false);
  const clearSerachBySelect = () => {
    setDepartmentId(0);
    setDesignationId(0);
    setRoleId(0);
    setActiveStatus(2);
  };

  const exportExcelDownload = () => {
    exportExcel(
      `${baseURL}/api/Export/DesignationExcelExport?DesignationID=${designationId}&RoleID=${roleId}&DepartmentID=${departmentId}&Status=${activeStatus}&PageSize=${PageSize}&CurrentPage=${currentPage}`,
      "Designations.xlsx",
      setDownloadIsLoading
    );
  };

  // Page navigation
  let navigate = useNavigate();
  const goToSettingPage = () => {
    navigate(-1);
  };
  // page navigation

  return (
    <div id="main-page">
      {userDetails !== null && userDetails !== "" && loggedInRole != 2 ? (
        <>
          {/* SIDEBAR START */}
          <Sidenavbar menuCollapse={menuCollapse} toggleshift={toggleshift} />
          {/* SIDEBAR END */}

          {/* TOPBAR START */}
          <Topbar
            toggleMenu={toggleMenu}
            menuCollapse={menuCollapse}
            toggleshift={toggleshift}
          />
          {/* TOPBAR END */}

          {/* MAIN BODY START */}
          <div className="page-wrapper">
            {/* PAGE CONTENT START */}
            <div className={`main-body ${toggleshift.style}`}>
              <div className="page-content">
                {/* Header and Filter Section */}
                <div style={{ position: "relative" }}>
                  <Row className="search-row">
                    <Col md={3} sm={4} xs={12} className="cat-col">
                      <div className="page-header-text-div">
                        <div className="back-btn" onClick={goToSettingPage}>
                          <img
                            src="../../../../images/DefaultImages/back-btn-arrow.svg"
                            alt=""
                          />
                        </div>
                        <h6 className="page-header-text">DESIGNATION</h6>
                      </div>
                    </Col>
                    <Col md={9} sm={8} xs={12} className="cat-col">
                      <div
                        className="search-bar-header"
                        style={{ float: "right" }}
                      >
                        <div className="page-top-bar-dropdowns page-top-Filters">
                          <div
                            className="header-filter-btn"
                            onClick={() => setOpenFilterTab(!openFilterTab)}
                          >
                            <div className="filter-icon-text">
                              <i className="bi bi-sliders" />
                              <span>Filters</span>
                            </div>
                          </div>
                          <SbAddBtn onClickEffect={() => setShow(!show)} />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {openFilterTab && (
                    <div className="page-filter-section">
                      <div className="filter-row-input-boxes">
                        <div>
                          <Select
                            className="react-select-container-list"
                            classNamePrefix="react-select-list"
                            options={departmentDrop}
                            placeholder="Select Department"
                            value={
                              departmentId == 0 ? "" : departmentDrop.value
                            }
                            onInputChange={departmentDrop.label}
                            onChange={(data) => setDepartmentId(data.value)}
                            isSearchable={true}
                          />
                        </div>
                        <div>
                          <Select
                            className="react-select-container-list"
                            classNamePrefix="react-select-list"
                            options={departDesignation}
                            placeholder="Select Designation"
                            value={
                              designationId == 0 ? "" : departDesignation.value
                            }
                            onInputChange={departDesignation.label}
                            onChange={(data) => setDesignationId(data.value)}
                            isSearchable={true}
                          />
                        </div>
                        <div>
                          <Select
                            className="react-select-container-list"
                            classNamePrefix="react-select-list"
                            options={rolesDropdown}
                            placeholder="Select Role"
                            value={roleId == 0 ? "" : rolesDropdown.value}
                            onInputChange={rolesDropdown.label}
                            onChange={(data) => setRoleId(data.value)}
                            isSearchable={true}
                          />
                        </div>
                        <div>
                          <Select
                            className="react-select-container-list"
                            classNamePrefix="react-select-list"
                            options={optionsStatusList}
                            placeholder="Select Status"
                            value={
                              activeStatus == 2 ? "" : optionsStatusList.value
                            }
                            onInputChange={optionsStatusList.label}
                            onChange={(data) => setActiveStatus(data.value)}
                            isSearchable={true}
                          />
                        </div>
                        <MiClearButton
                          onClickEffect={clearSerachBySelect}
                          btnName="Clear"
                        />
                      </div>
                    </div>
                  )}
                </div>
                {/* Header and Filter Section */}
                <DesignationTable
                  tableHeader={tableHeader}
                  designationData={designationData}
                  isLoading={isLoading}
                  setShow={setShow}
                  show={show}
                  setEditDesignationID={setEditDesignationID}
                  loading={loading}
                  setPageSize={setPageSize}
                  PageSize={PageSize}
                  setLoading={setLoading}
                  totalData={totalData}
                />
                {/* USER TABLE START */}
                <div className="designation-table">
                  <div className="download-and-pagination">
                    <SbDownloadBtn onClickEffect={exportExcelDownload} />
                  </div>
                </div>
                {/* USER TABLE END */}

                {/* ADD MODEL START */}
                {show ? (
                  <AddDesignation
                    show={show}
                    handleClose={handleClose}
                    fetchDesignations={fetchDesignations}
                    editDesignationID={editDesignationID}
                  />
                ) : (
                  ""
                )}
                {/* ADD MODEL END */}

                {/* PAGE CONTENT END*/}
              </div>
            </div>

            {/* MAIN BODY END */}
          </div>
          <Footer />
          {downloadIsLoading && (
            <>
              <DownloadLoading />
            </>
          )}
        </>
      ) : (
        <AccessDenied />
      )}
    </div>
  );
}
